import roundToDecimals from "PFCore/helpers/round_to_decimals";
import { useTranslation } from "react-i18next";

const getTimeLabel = (minutes: number): string => `${roundToDecimals(minutes / 60)}h`;

type UseAvailabilityLabel = {
  availableMinutes: number;
};

export const useAvailabilityLabel = ({ availableMinutes }: UseAvailabilityLabel): string => {
  const { t } = useTranslation("bookingModule");
  if (availableMinutes === 0) {
    return t("workforce.availability.full");
  }
  const timeLabel = getTimeLabel(Math.abs(availableMinutes));

  if (availableMinutes > 0) {
    return t("workforce.availability.free", { timeLabel });
  }
  return t("workforce.availability.over", { timeLabel });
};
